import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, CreditCardIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
import { heroBullets, PACK_IMAGE } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <header className="border-b border-line bg-canvasAlt" data-id="element-149" data-mp="4n1kkpc3c8rg">
      <div className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 pt-6 pb-8 lg:pt-8 lg:pb-10" data-id="element-150" data-mp="1297a3xzwwp6o">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.25,
        ease: EASE
      }} className="flex items-center justify-center gap-1.5 font-display text-xs font-bold uppercase tracking-[0.2em] text-accent" data-id="element-151" data-mp="xae74zi94gkr">
          <ZapIcon size={14} className="text-accent" data-id="element-152" data-mp="3d1ilrd3pdip0" />
          CM Digital Pro™
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.04
      }} className="mt-2 text-center font-display text-[1.75rem] leading-[1.1] sm:text-4xl lg:text-5xl font-black uppercase text-ink" data-id="element-153" data-mp="382fhvvzgliim">
          Convertí la Electrónica en{' '}
          <span className="text-accent" data-id="element-154" data-mp="399tdd14tkmbt">tu próximo emprendimiento</span>
        </motion.h1>

        <div className="mt-4 grid gap-x-10 gap-y-4 lg:grid-cols-[1.1fr_1fr] lg:items-center" data-id="element-155" data-mp="3e84rho25dizu">
          <motion.div initial={{
          opacity: 0,
          scale: 0.97
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.3,
          ease: EASE,
          delay: 0.08
        }} className="order-1 rounded-2xl border border-line bg-surface p-2 sm:p-3 lg:row-span-2 lg:self-center" data-id="element-156" data-mp="30h9d5w8vq9ov">
            <img src={PACK_IMAGE} alt="Mega Pack Electrónica para Emprender: 6 cursos y 6 bonos con herramientas, componentes, reparación y proyectos" className="mx-auto w-full" data-id="element-157" data-mp="2vjg9payyntsa" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease: EASE,
          delay: 0.12
        }} className="order-2 lg:order-3 lg:col-start-2" data-id="element-158" data-mp="s2joo1a4k8lm">
            <CtaButton href="#pricing" size="lg" data-id="element-159" data-mp="ichx2zikc81y">
              Quiero empezar hoy mismo
            </CtaButton>
            <div className="mt-3 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-ink-muted" data-id="element-160" data-mp="dbapp1kc1avt">
              <span className="flex items-center gap-1.5" data-id="element-161" data-mp="1ayjg9az6xa4o">
                <ShieldCheckIcon size={14} className="text-success" data-id="element-162" data-mp="16344cokqtoaw" />
                Garantía 7 días
              </span>
              <span className="flex items-center gap-1.5" data-id="element-163" data-mp="110wqtuk9m06g">
                <LockIcon size={14} className="text-ink-subtle" data-id="element-164" data-mp="x1wb4kx33dno" />
                Pago seguro
              </span>
              <span className="flex items-center gap-1.5" data-id="element-165" data-mp="3ltqbtahzursg">
                <CreditCardIcon size={14} className="text-volt" data-id="element-166" data-mp="3hrlk4hb3w58g" />
                Mercado Pago
              </span>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease: EASE,
          delay: 0.16
        }} className="order-3 lg:order-2 lg:col-start-2" data-id="element-167" data-mp="1xb5pse406rg4">
            <p className="text-base md:text-lg text-ink-muted leading-relaxed" data-id="element-168" data-mp="2b1966og7bqxn">
              El sistema práctico que reúne en un solo lugar lo que necesitás
              para <span className="font-semibold text-ink" data-id="element-169" data-mp="2g1wu3194vrnn">aprender</span>,{' '}
              <span className="font-semibold text-ink" data-id="element-170" data-mp="2kxc5znnkzdhf">practicar</span> y
              empezar a generar oportunidades con Electrónica.
            </p>

            <p className="mt-3 inline-flex items-center rounded-lg border border-accent/40 bg-accent-soft px-3 py-1.5 font-display text-xs font-bold uppercase tracking-wide text-accent" data-id="element-171" data-mp="2tzbnsi6f6llf">
              Mega Pack Electrónica para Emprender
            </p>

            <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-172" data-mp="zlswvr6wa193">
              {heroBullets.map(bullet => <li key={bullet} className="flex items-start gap-2 text-sm md:text-base text-ink" data-id="element-173" data-mp="4dgy4w0stp8n">
                  <CheckIcon size={15} className="mt-1 flex-shrink-0 text-volt" strokeWidth={3} data-id="element-174" data-mp="e9trttwcg33e" />
                  <span data-id="element-175" data-mp="3hq0ubx30vual">{bullet}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </header>;
}